module.exports = __webpack_public_path__ + "static/media/logoNewBright.8950242f.png";